<template>
  <div id="container" v-loading="loadedRatio === 0 || loadedRatio !== this.pdfPages">
    <div v-for="page in pdfPages" :key="page" class="pdf-page">
      <pdf @page-loaded="loadedRatio = $event"  :src="pdfUrl" :page="page" width="100%" height="100%" frameborder="0"></pdf>
      <div style="background: #ccc;opacity: 0.7;height: 1px;"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  computed: {
    ...mapGetters(['lang']),
  },
  data() {
    return {
      loading: true,
      pdfPages: 0,
      loadedRatio: 0,
    }
  },
  created() {
    const url = this.lang === 'TH' ? 'https://cms.jtexpress.com/ccm/th/open/PrivacyPolicyThai.pdf' : 'https://cms.jtexpress.com/ccm/th/open/PrivacyPolicyEnglish.pdf'
    this.getPdfTotal(url)
  },
  watch: {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    getPdfTotal(filePath) {
      this.pdfUrl = pdf.createLoadingTask(filePath)
      // 获取页码
      this.pdfUrl.promise.then((pdf, option) => {
        console.log(option, 'option')
        this.pdfPages = pdf.numPages;
        console.log("🚀 ~ getPdfTotal ~ this.pdfPages:", this.pdfPages)
      }).catch(error => {
        console.error('getPdfTotal error::', error);
      })
    },
  }
}
</script>

<style scoped lang="scss">
#container {
  .page-num {
    text-align: center;
    font-size: 14px;
  }
}
</style>